/* SHARED */

import { combineReducers, Reducer } from 'redux';
import authReducer from './auth/reducer';
import apiReducer from './api/reducer';

const allReducers: Reducer<any> | any = combineReducers({
    auth: authReducer,
    api: apiReducer,
});

export default allReducers;
